import { useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff, UserRound } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { CandidateContactPanel } from "@/components/si/CandidateActions";
import { useSiMe } from "@/lib/sourcing";

// §103 The real person behind an MPC: always visible to you and your clients.
export const MpcCandidate = ({ row }) => {
  const me = useSiMe();
  const c = row.candidate;
  const [vis, setVis] = useState(row.company_visibility || "anonymous");
  const anon = vis !== "named";
  const flip = async () => {
    const next = anon ? "named" : "anonymous";
    try { await api.patch(`/admin/rcc/mpcs/${row.id}`, { company_visibility: next }); setVis(next); toast.success(next === "named" ? "Companies will now see their name" : "Companies will now see them anonymously"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-5 space-y-3 rounded-xl border border-[#27272A] bg-[#0f0f12] p-4" data-testid="mpc-candidate">
      <div className="flex flex-wrap items-center gap-2">
        <UserRound className="h-4 w-4 text-[#D4AF37]" />
        <p className="font-display text-base text-zinc-50" data-testid="mpc-candidate-name">{c?.full_name || row.candidate_name || "Candidate"}</p>
        {c?.current_title && <span className="text-xs text-zinc-400">{[c.current_title, c.current_employer].filter(Boolean).join(" · ")}</span>}
        <button type="button" onClick={flip} disabled={me.readOnly} title="Click to switch what companies see" className={`ml-auto inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] transition-colors hover:bg-white/5 ${anon ? "border-amber-500/40 text-amber-300" : "border-emerald-500/40 text-emerald-300"}`} data-testid="mpc-visibility">{anon ? <><EyeOff className="h-3 w-3" />Anonymous to companies</> : <><Eye className="h-3 w-3" />Named to companies</>}</button>
      </div>
      {c?.id ? <CandidateContactPanel c={c} endpoint={`/admin/rcc/mpcs/${row.id}/candidate`} recordSource="mpc" campaign={{ source: "mpc", ids: [row.id] }} readOnly={me.readOnly} />
        : <p className="text-xs text-zinc-500" data-testid="mpc-candidate-missing">The candidate's contact details will show here once the server returns them (spec §103).</p>}
    </div>
  );
};
